import React from "react";
import { useNavigate } from "react-router-dom";

import smm from "../Assets/serv/socialmediamarketing.jpeg";
import seo from "../Assets/serv/SEO Search Engine Optimization agancy.png";
import pm from "../Assets/newservices/Performance Marketing1.jpeg";
import wa from "../Assets/newservices/Web Analytics.jpeg";
import wdd from "../Assets/newservices/Website Design & Development.jpeg";
import email from "../Assets/newservices/Email Marketing.jpeg";
import gd from "../Assets/serv/graphic design.jpeg";
import wm from "../Assets/newservices/Website Management.jpeg";

const services = [
  {
    title: "Social Media Marketing",
    desc: "Grow your brand presence across all major social platforms.",
    image: smm,
  },
  {
    title: "Search Engine Optimization (SEO)",
    desc: "Rank higher on Google and drive organic traffic.",
    image: seo,
  },
  {
    title: "Performance Marketing",
    desc: "Data-driven ads that deliver measurable ROI.",
    image: pm,
  },
  {
    title: "Web Analytics",
    desc: "Track, analyze, and improve your digital performance.",
    image: wa,
  },
  {
    title: "Website Design & Development",
    desc: "Modern, responsive, and high-converting websites.",
    image: wdd,
  },
  {
    title: "Website Management",
    desc: "Ongoing updates, security, and performance optimization.",
    image: wm,
  },
  {
    title: "Email Marketing",
    desc: "Engage customers and boost conversions through email campaigns.",
    image: email,
  },
  {
    title: "Graphic Design",
    desc: "Creative visuals that strengthen your brand identity.",
    image: gd,
  },
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-white py-0 px-4 sm:px-6 lg:px-10 mt-[25%] sm:mt-[12%]">

      {/* Heading */}
      <div className="text-center mb-16">
        <h2 className="text-3xl sm:text-5xl font-bold text-gray-900">
          Services that make your business stand out
        </h2>
      </div>

      {/* GRID */}
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">

        {services.map((service, index) => (
          <div
            key={index}
            className="group bg-white border border-gray-200 rounded-2xl overflow-hidden flex flex-col hover:shadow-xl transition duration-300"
          >

            {/* IMAGE */}
            {/* <div className="overflow-hidden">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-56 object-cover object-all"
              />
            </div> */}
            {/* IMAGE */}
            <div className="w-full h-56 overflow-hidden bg-gray-100">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition duration-500"
              />
            </div>

            {/* CONTENT */}
            <div className="p-5 flex flex-col flex-1">

              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-[#f99728] transition">
                {service.title}
              </h3>

              <p className="text-gray-600 text-sm mt-2 flex-1">
                {service.desc}
              </p>

              {/* BUTTON ALWAYS AT BOTTOM */}
              {/* <button
                onClick={() => navigate("/contact")}
                className="mt-4 text-sm font-medium text-black group-hover:text-[#f99728]"
              >
                Learn more →
              </button> */}
              {/* <button
                onClick={() => navigate("/contact")}
                className="mx-auto flex items-center gap-1 px-4 py-2 text-xs md:text-sm font-medium text-white bg-[#f99728] rounded-full shadow-md transition-all duration-300 hover:bg-blue-600 hover:shadow-lg hover:-translate-y-0.5"
              >
                Learn more
                <span className="transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </button> */}
              <div className="w-full flex justify-start mt-4">
                <button
                  onClick={() => navigate("/contact")}
                  className="inline-flex items-center gap-1 px-3 py-3 text-xs font-medium text-white bg-[#f99728] rounded-full shadow-sm transition-all duration-300 hover:bg-blue-600 hover:shadow-md hover:-translate-y-0.5"
                >
                  Learn more
                  <span className="transition-transform duration-300 group-hover:translate-x-1">
                    →
                  </span>
                </button>
              </div>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;